/**
 * Operator home (DESIGN.md §4.2 #2): the 5 service tiles, rendered FROM THE
 * REGISTRY (labels + order from the descriptors — zero hardcoded service
 * lists anywhere in the client). Tiles ≥120px; tap = job start.
 * The New-inquiries surface on home IS the rail's pinned entry (one
 * accessible 'Web enquiries' button app-wide — net strict-mode rule).
 */
import type { JSX } from 'preact';
import { serviceTiles, type Registry } from '../store/registry.js';
import { PlaneIcon, GolfIcon, RingsIcon, BusIcon } from '../components/icons.js';

export type HomeProps = {
  registry: Registry;
  onStartJob: (serviceId: string) => void;
};

/** Recognition icon per service — DECORATIVE only (the registry label is the
 *  content; an unknown/new serviceId simply renders with the default icon).
 *
 *  ⛔ AN ENTRY ONLY FOR A SERVICE THAT CAN TILE (K5-8). The tiles render only
 *  from `serviceTiles(registry)`, which filters on `offeredServiceIds`
 *  (`KIOSK_SERVICE_IDS`, shared/service-schema.ts), so an entry for any other
 *  service is unreachable, and an unreachable map row reads as evidence that
 *  the service still ships. Hence no `private-tour` (retired) and, since board
 *  2814 M6 (DD-8), no `nursing-home`: nursing work is booked from the Nursing
 *  homes area, never the calculator. */
const TILE_ICONS: Record<string, () => JSX.Element> = {
  airport: () => <PlaneIcon size={34} />,
  golf: () => <GolfIcon size={34} />,
  wedding: () => <RingsIcon size={34} />,
  'local-other': () => <BusIcon size={34} />,
};

export function Home({ registry, onStartJob }: HomeProps) {
  return (
    <div class="screen-pane">
      <h1 class="screen-title" tabIndex={-1}>What type of journey?</h1>
      <div class="tile-grid">
        {serviceTiles(registry).map((t) => {
          const Icon = TILE_ICONS[t.serviceId] ?? (() => <BusIcon size={34} />);
          return (
            <button key={t.serviceId} type="button" class="tile" onClick={() => onStartJob(t.serviceId)}>
              <span class="tile-icon"><Icon /></span>
              <span class="tile-label">{t.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
